module.exports = __webpack_public_path__ + "static/media/firewall.d2310610.webp";